// src/auth/AuthProvider.tsx
import React, { ReactNode, FC } from "react";
import * as ReactMsal from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";

interface AuthProviderProps {
  instance: IPublicClientApplication;
  children: ReactNode;
}

const AuthProvider: FC<AuthProviderProps> = ({ instance, children }) => {
  const MsalProvider: any = ReactMsal.MsalProvider;
  return <MsalProvider instance={instance}>{children}</MsalProvider>;
};

export default AuthProvider;
